/**
 * Created by studio@linelab.pl on 2017-05-26.
 * Version 1.2
 */
(function ($) {

    pw.doc('Segment', '1.2.180425', ['segment:load[data-segment]', 'segment:reload[data-segment]']);

    $(document)
        .on('pw.segment', '[data-segment]', function (e, uri) {
            console.warn('Deprecated trigger: pw.segment use segment:load or segment:load.pw', 'Rewrite Event to segment:load.pw');
            $(this).trigger('segment:load.pw', [uri]);
        })
        // once load segment
        .on('segment:load.pw', '[data-segment]', function (e, uri) {

            var u = $(this),
                url = uri || u.attr('data-segment'),
                wrapper = (u.attr('data-segment-target')) ? $(u.attr('data-segment-target')) : u,
                params = wrapper.data('requestParams')
            ;

            if ((url && !wrapper.hasClass('pw-segment-loaded')) || uri) {
                    wrapper.addClass('pw-segment-loaded').addClass('loading');
                    $.get("" + url, params, function (data) {
                        pw.ajaxContent.apply(e.target, [data, wrapper]);
                    });
            }

        })
        // reload segment
        .on('segment:reload.pw', '[data-segment]', function (e, uri) {
            $(this)
                .removeClass('pw-segment-loaded')
                .trigger('segment:load.pw', [uri]);
        })
        // ajax buttons and url
        .on('click', 'a[data-ajax-url], button[data-ajax-url]', function (event) {

            var $e = $(this),
                url = (!$e.attr('data-ajax-url')) ? $e.attr('href') : $e.attr('data-ajax-url'),
                target = (($e.attr('data-target')) ? $($e.attr('data-target')) : $('body')),
                wrapper = target,
                m = $e.attr('data-target-method'),
                method =  m || 'append'
            ;
            if (url) {

                event.preventDefault();
                wrapper.addClass('loading');

                $.get(url, function (data) {
                    pw.ajaxContent.apply(event.target, [data, wrapper, method]);
                });

            }
        })
        .on('click', '[data-segment-refresh]', function (e) {

            var selectors = $(this).attr('data-segment-refresh');

            if(selectors) {
                $(''+ selectors).trigger('segment:reload.pw');
            }

        });
    ;

    $(document).ready(function() {
        setTimeout(function () {
            $('[data-segment]').trigger('segment:load');
        }, 50);
    });



})(jQuery);